import { Component, Inject, inject } from '@angular/core';
import { AppConfig } from '../app.config';

@Component({
  templateUrl: './short-url.component.html',
  styleUrls: ['./short-url.component.scss'],
})
export class ShortURLComponent {
  options = {
    path: this.config.ANIMATIONS_PATH + 'error.json',
    loop: false,
  };

  constructor(@Inject(AppConfig) private config: AppConfig) {}
}
